// extracted by mini-css-extract-plugin
export default {"container":"bnc_1i7Tg"};